import { Injectable } from '@angular/core';
import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';

@Injectable()
export class DeutschPaginatorIntl extends MatPaginatorIntl {

    override firstPageLabel = 'Erste Seite';
    override lastPageLabel = 'Letzte Seite';
    override nextPageLabel = 'Nächste Seite';
    override previousPageLabel = 'Vorherige Seite';
    override itemsPerPageLabel = 'Einträge pro Seite';

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        const of = 'von';
        if (length === 0 || pageSize === 0) {
            return "0 " + of + " " + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize > length ? (Math.ceil(length / pageSize) - 1) * pageSize : page * pageSize;

        const endIndex = Math.min(startIndex + pageSize, length);
        return startIndex + 1 + " - " + endIndex + " " + of + " " + length;
    };
}